module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-selector"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "col",
      class: {
        isSelectedTab: _vm.getValue(item) === _vm.value
      },
      domProps: {
        "textContent": _vm._s(_vm.getText(item))
      },
      on: {
        "click": function($event) {
          _vm.selectItem(_vm.getValue(item))
        }
      }
    })
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28e94da2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings/TabSelector/TabSelector.vue
// module id = 3095
// module chunks = 1